import React from "react";
import { Paper, Typography } from "@material-ui/core";
import { SvgIconComponent } from "@material-ui/icons";
import { workflowCardStyles, workflowCardHoverHandlers } from "../styles";

interface WorkflowCardProps {
  icon: SvgIconComponent;
  title: string;
  description: string;
  onClick: () => void;
}

const WorkflowCard: React.FC<WorkflowCardProps> = ({
  icon: Icon,
  title,
  description,
  onClick,
}) => {
  // Split description by <br /> tags and render as separate lines
  const descriptionLines = description.split(/<br\s*\/?>/i);

  return (
    <Paper
      style={workflowCardStyles.base}
      elevation={0}
      onClick={onClick}
      {...workflowCardHoverHandlers}
    >
      <div style={workflowCardStyles.titleContainer}>
        <div style={workflowCardStyles.iconContainer}>
          <Icon style={workflowCardStyles.icon} />
        </div>
        <Typography variant="h6" style={workflowCardStyles.title}>
          {title}
        </Typography>
      </div>
      <Typography variant="body2" style={workflowCardStyles.description}>
        {descriptionLines.map((line, index) => (
          <React.Fragment key={index}>
            {line}
            {index < descriptionLines.length - 1 && <br />}
          </React.Fragment>
        ))}
      </Typography>
    </Paper>
  );
};

export default WorkflowCard;
